module.exports = __webpack_public_path__ + "static/img/03_img.4dd3878.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company/sustainability/03_img.png
// module id = DVkJ
// module chunks = 0